/** Accepts a DC or DM card number */
export const dcOrDmCardNumber = /^((DC\d{5})|(DM\d{7}))$/i; // DC followed by 5 digits or DM followed by 7 digits

/** Accepts a DC card number */
export const dcCardNumber = /^DC\d{5}$/i; // DC followed by 5 digits

/** Accepts a DM card number */
export const dmCardNumber = /^DM\d{7}$/i; // DM followed by 7 digits

const withoutCardPrefix = (cardNumber: string) => cardNumber.replace(/^(DC|DM)/i, "");

/** Get just the number from a card number */
export const stripCardNumberPrefix = (cardNumber: string | undefined | null) => {
  return cardNumber?.match(dcOrDmCardNumber)?.[0]?.substring(2);
};

/** Format a Dust Card Number for display */
export const formatDustCardNumber = <T extends string | undefined | null>(cardNumber: T) => {
  return cardNumber ? `DC${withoutCardPrefix(cardNumber)}` : cardNumber;
};

/** Format a Dust Monitor Card Number for display */
export const formatDustMonitorCardNumber = <T extends string | undefined | null>(cardNumber: T) => {
  return cardNumber ? `DM${withoutCardPrefix(cardNumber)}` : cardNumber;
};

/** Format a DC or DM card number for display (picks the prefix from the value). */
export const formatDustOrMonitorCardNumber = <T extends string | undefined | null>(cardNumber: T) => {
  if (!cardNumber) return cardNumber;
  const digits = withoutCardPrefix(cardNumber);
  if (/^DM/i.test(cardNumber.trim()) || /^\d{7}$/.test(digits)) {
    return formatDustMonitorCardNumber(cardNumber);
  }
  return formatDustCardNumber(cardNumber);
};
